import { render, staticRenderFns } from "./EfsMdChickenPriceForm.vue?vue&type=template&id=404f3d33&"
import script from "./EfsMdChickenPriceForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdChickenPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports